class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
    document.querySelectorAll('button[type="button"][data-target^="details-modal"]').forEach((button) => button.addEventListener('click', this.onRemoteClick.bind(this)));
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onRemoteClick(event) {
    event.preventDefault();
    if(this.matches(event.target.closest('[data-target]').dataset.target)) {
      setTimeout(() => {
        this.summaryToggle.click();
      });
    }
  }
  
  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    if(this.matches('.header__search')) document.body.classList.add('header-search-open');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if(this.matches('.header__search')) {
      document.body.classList.remove('header-search-open');
      if(document.body.classList.contains('header-drawer-open')) {
        if(document.querySelector('.header-drawer-submenu-open')) {
          trapFocus(document.querySelector('header-drawer .submenu-open details[open]'), document.querySelector('header-drawer .submenu-open details[open] .menu-drawer-header__menu-button'));
        } else {
          trapFocus(document.querySelector('header-drawer > details'), document.querySelector('header-drawer > details > summary'));
        }
      }
    }
  }
}

customElements.define('details-modal', DetailsModal);
